import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

import cover1 from "themes/assets/hero-images/cover_1.jpg";
import cover2 from "themes/assets/hero-images/cover_2.jpg";
import cover3 from "themes/assets/hero-images/cover_3.jpg";
import cover4 from "themes/assets/hero-images/cover_4.jpg";
import { LazyImage } from "common/components";

const heroImages = [cover1, cover2, cover3, cover4];
function PublicLayoutTemplate({ renderChildRoute, ...props }) {
    const [currentImage, setCurrentImage] = useState(cover1);

    useEffect(() => {
        let count = parseInt(localStorage.getItem("current-hero-count") || "0", 10);

        if (count >= heroImages.length) {
            count = 0;
        }

        setCurrentImage(heroImages[count]);

        localStorage.setItem("current-hero-count", count + 1);
    }, []);

    return (
        <div className="l__public">
            <div className="c-membership__hero">
                <LazyImage src={currentImage} alt="Membership Hero" className="c-membership__hero__image" />
            </div>

            {renderChildRoute(props)}
        </div>
    );
}

PublicLayoutTemplate.propTypes = {
    renderChildRoute: PropTypes.func,
};

export default PublicLayoutTemplate;
